export type PeriodPreset = 'week' | 'month' | 'quarter' | 'year' | 'custom'

export interface PeriodParams {
    period_start?: string
    period_end?: string
}

/**
 * Date range sent to the statistics endpoint for a preset.
 *
 * Every branch derives `end` from the period's own start instead of from the
 * current date: `setDate()`/`setMonth()` only move one field, so reading a
 * mutated `start` while `end` still points at today silently overflows into the
 * next month — which made "Неделя" span five weeks and report more tasks than
 * "Месяц".
 */
export function getPeriodParams(
    preset: PeriodPreset,
    customStart: string,
    customEnd: string,
    today: Date = new Date(),
): PeriodParams {
    if (preset === 'custom') {
        return {
            ...(customStart ? {period_start: new Date(`${customStart}T00:00:00`).toISOString()} : {}),
            ...(customEnd ? {period_end: new Date(`${customEnd}T23:59:59.999`).toISOString()} : {}),
        }
    }

    const start = new Date(today)
    const end = new Date(today)

    if (preset === 'week') {
        const weekday = start.getDay() || 7
        start.setDate(start.getDate() - weekday + 1)
        end.setTime(start.getTime())
        end.setDate(end.getDate() + 6)
    } else if (preset === 'month') {
        const month = start.getMonth()
        start.setDate(1)
        end.setDate(1)
        end.setMonth(month + 1, 0)
    } else if (preset === 'quarter') {
        const quarterStart = Math.floor(start.getMonth() / 3) * 3
        start.setMonth(quarterStart, 1)
        end.setDate(1)
        end.setMonth(quarterStart + 3, 0)
    } else {
        start.setMonth(0, 1)
        end.setMonth(11, 31)
    }

    start.setHours(0, 0, 0, 0)
    end.setHours(23, 59, 59, 999)

    return {period_start: start.toISOString(), period_end: end.toISOString()}
}
